export default {
    getStoredEventById: (state) => (id) => {
        const event = state.events.find(event => event.id === id)
        if (event === undefined) {
            state.events.push({ id: id })
            return state.events.find(event => event.id === id)
        } else {
            return event
        }
    },
    getStoredEventsByPage: (state) => (page = 1) => {
        if (isNaN(page)) {
            page = 1
        }
        return state.events.filter(event => event.page === page)
    },
    getEventPages: state => {
        return state.event_pages
    },
    getNewEvent: state => {
        return state.newEvent = {
            name: '',
            description: '',
            start: new Date().toDateString(),
            end: new Date().toDateString(),
            start_time: "00:00:00",
            end_time: "00:00:00"
        }
    },
    getStoredCalendars: state => {
        return state.calendars
    },
    getStoredCalendarById: (state) => (id) => {
        const calendar = state.calendars.find(calendar => calendar.id === id)
        if (calendar === undefined) {
            state.calendars.push({ id: id })
            return state.calendars.find(calendar => calendar.id === id)
        } else {
            return calendar
        }
    },
    getNewCalendar: state => {
        return state.new_calendar
    },
}
